import { Box } from "@mui/material";
import { useEasierTheme } from "datalign-themes";
import React, { useEffect, useRef } from "react";
import DOMPurify from "dompurify";
import Quill from "quill";
import InputField from "models/input/input-field";

const RichTextField = ({
  label,
  field,
  searchCard,
}: {
  label?: string;
  field: InputField;
  searchCard?: boolean;
}) => {
  const theme = useEasierTheme();

  function truncateString(string: string) {
    if (string.length > 300) {
      return string.substring(0, 300 - 3) + "...";
    }
    return string;
  }
  const containerRef = useRef<HTMLDivElement>(null);
  const quillRef = useRef<Quill | null>(null);

  useEffect(() => {
    const container = containerRef.current;

    if (!container || quillRef.current) return;

    // Create read-only Quill instance
    quillRef.current = new Quill(container, {
      readOnly: true,
      modules: { toolbar: false },
      theme: "snow",
    });

    // Paste saved HTML into the editor
    quillRef.current.clipboard.dangerouslyPasteHTML(
      DOMPurify.sanitize(field.data),
    );

    // Optional: clean up styles
    const editorEl = container.querySelector(".ql-editor") as HTMLDivElement;
    if (editorEl) {
      editorEl.style.minHeight = "20px";
      editorEl.style.backgroundColor = "inherit";
      editorEl.style.border = "none";
    }

    // Cleanup on unmount
    return () => {
      if (container) container.innerHTML = "";
      quillRef.current = null;
    };
  }, []); // empty deps: init once

  // When htmlContent changes, update the content
  useEffect(() => {
    if (quillRef.current) {
      quillRef.current.clipboard.dangerouslyPasteHTML(
        DOMPurify.sanitize(field.data),
      );
    }
  }, [field.data]);
  return (
    <Box sx={{ p: 0 }}>
      {searchCard ? (
        truncateString(field.data.replace(/(<([^>]+)>)/gi, ""))
      ) : (
        <div
          ref={containerRef}
          style={{
            margin: 0,
            padding: 0,
            lineHeight: 1.5,
            whiteSpace: "normal",
            fontSize: "1rem",
            fontFamily: '"proxima",sans-serif',
          }}
        />
      )}
    </Box>
  );
};

export default RichTextField;
